import { useContext, useState } from "react";
import UiContext from "../../../../store/ui-context";
import useAPIRequest from "../../../../custom_hooks/simple/useAPIRequest";
import { useSelector } from "react-redux";
import { format, addDays } from "date-fns";

const defaultTake = 10;

export const useAPIGetReportCustomerFreeProduct = () => {
  const uiContext = useContext(UiContext);
  const { requestGet, loading } = useAPIRequest();
  const employee = useSelector((state) => state.auth.employee);

  const [filterValue, setFilterValue] = useState({
    customer_id: null,
    data_customer: null,
    name: "",
    nearExpiredDays: 0,
    expiredBefore: null,
    usageStatus: 1,
    dateFrom: null,
    dateTo: null,
    showExpired: false,
  });

  const [paging, setPaging] = useState({
    page: 1,
    take: defaultTake,
    total: 0,
    filter: "",
  });

  const [listData, setListData] = useState([]);

  // API call section

  const fetchListData = async ({ page, take, filter, filterValueOverride }) => {
    let newFilter = filter ?? getFilter(filterValueOverride ?? filterValue);

    // BC hanya bisa lihat customer dia sendiri
    if (employee?.user_type == 3) {
      newFilter = `data_customer.bc_id:=:${employee?.id}${newFilter ? `;${newFilter}` : ""}`;
    }

    requestGet({
      fullUrl: `/api/customer/customerfreeproduct/data`,
      params: {
        page,
        take,
        filter: newFilter || undefined,
        order: "expired_date",
        order_method: "ASC",
        "with_customer,data_bc": 1,
        with_product: 1,
        "with_usage_sales_item,data_sales": 1,
        "with_source_sales_item,data_sales": 1,
      },
      onSuccess: ({ pagination, data }) => {
        setPaging({
          ...paging,
          total: pagination.total,
          page: pagination.page,
          take: pagination.take,
          filter: newFilter,
        });
        setListData(data.map((el, i) => ({ ...el, no: (page - 1) * take + i + 1 })));
      },
      onError: ({ message }) => {
        uiContext.showErrorMsg("Error", message);
      },
    });
  };

  // other function section

  const getFilter = (_filterValue) => {
    const filterArr = [];
    const newFilterValue = _filterValue ?? filterValue;

    if (newFilterValue.customer_id) {
      filterArr.push(`customer_id:=:${newFilterValue.customer_id}`);
    }

    if (newFilterValue.name) {
      filterArr.push(`data_product.name:contains:${newFilterValue.name}`);
    }

    if (!newFilterValue.showExpired) {
      if (newFilterValue.nearExpiredDays) {
        const today = format(addDays(new Date(), 1), "yyyy-MM-dd");
        const limitDate = format(
          addDays(new Date(), parseInt(newFilterValue.nearExpiredDays) + 1),
          "yyyy-MM-dd"
        );
        filterArr.push(`expired_date:>=:${today}`);
        filterArr.push(`expired_date:<=:${limitDate}`);
      } else if (newFilterValue.expiredBefore) {
        filterArr.push(
          `expired_date:<=:${format(new Date(newFilterValue.expiredBefore), "yyyy-MM-dd")}`
        );
      } else {
        filterArr.push(`expired_date:>=:${format(new Date(), "yyyy-MM-dd")}`);
      }
    }

    if (newFilterValue.usageStatus === 1) {
      filterArr.push(`usage_sales_item_id:=:Null`);
    } else if (newFilterValue.usageStatus === 2) {
      filterArr.push(`usage_sales_item_id:!=:Null`);
    }

    if (newFilterValue.dateFrom) {
      filterArr.push(
        `created_at:>=:${format(new Date(newFilterValue.dateFrom), "yyyy-MM-dd")} 00:00:00`
      );
    }
    if (newFilterValue.dateTo) {
      filterArr.push(
        `created_at:<=:${format(new Date(newFilterValue.dateTo), "yyyy-MM-dd")} 23:59:59`
      );
    }

    return filterArr.join(";");
  };

  // handle ui event section

  const handleOnClickRefresh = async (filterValueOverride) => {
    fetchListData({ page: 1, take: defaultTake, filterValueOverride });
  };

  const handleOnPage = (e) => {
    const newPage = e.first / paging.take + 1;
    const newTake = e.rows;

    setPaging({ ...paging, take: newTake, page: newPage });
    fetchListData({ page: newPage, take: newTake, filter: paging.filter });
  };

  const handleOnUpdateViewRow = () => {
    fetchListData({ page: paging.page, take: paging.take, filter: paging.filter });
  };

  const handleOnDeleteViewRow = () => {
    fetchListData({ page: paging.page, take: paging.take, filter: paging.filter });
  };

  return {
    loading,
    listData,
    fetchListData,
    filterValue,
    setFilterValue,
    getFilter,
    handleOnClickRefresh,
    handleOnPage,
    paging,
    handleOnUpdateViewRow,
    handleOnDeleteViewRow,
  };
};
